/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { AdWaypointPassengersWaypointFragmentDoc } from '../../../../../../../ad-passenger-list/src/lib/AdWaypointPassengers/AdWaypointPassengers.hook'
import { AdPassengerRowCustomerFragmentDoc } from '../../../../../../../ad-passenger-list/src/lib/components/AdPassengerRow/AdPassengerRow.hook'
import {
  GetPassengersDeliveryActionFragmentDoc,
  GetPassengersPickupActionFragmentDoc,
  GetPassengersWaypointFragmentDoc,
} from '../../../../../../../ad-passenger-list/src/lib/utils/passenger-filters.hook'
import * as Types from '../../../../../../../graphql/src/lib/graphql/generated/types'
import {
  AdVehicleStreamAlertVehicleMapLocationFragmentDoc,
  AdVehicleStreamAlertVehicleMapWaypointFragmentDoc,
} from '../../../../AlertVehicleMap/AlertVehicleMap.hook'
import { AdVehicleStreamEvaluateCabinSafetyCheckStatusFragmentDoc } from '../../../../evaluateCabinSafetyCheckStatus/evaluateCabinSafetyCheckStatus.hook'
import { AdVehicleStreamBoardingPassengersWaypointFragmentDoc } from '../../../BoardingPassengers/BoardingPassengers.hook'

const defaultOptions = {} as const
export type AdVehicleStreamUpcomingWaypointsQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamUpcomingWaypointsQuery = {
  __typename?: 'Query'
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    upcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      id: string
      adState: Types.FccWaypointState | null
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | { __typename: 'FccWaypointHubReturnAction' }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            notShownUpAt: string | null
            tripIsCancelled: boolean | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | { __typename: 'FccWaypointReallocationAction' }
      >
      fccStop: {
        __typename?: 'FccStop'
        id: string | null
        names: Partial<Record<'de' | 'en' | 'no', string>>
      } | null
      stopWithServiceArea: {
        __typename?: 'Stop'
        id: string
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
      stop: {
        __typename?: 'Stop'
        routingLocation: {
          __typename?: 'Location'
          latitude: number
          longitude: number
        }
      } | null
    }> | null
  }
}

export type AdVehicleStreamWaypointAttendanceModalWaypointFragment = {
  __typename?: 'FccWaypoint'
  id: string
  adState: Types.FccWaypointState | null
  fccStop: {
    __typename?: 'FccStop'
    id: string | null
    names: Partial<Record<'de' | 'en' | 'no', string>>
  } | null
  stopWithServiceArea: {
    __typename?: 'Stop'
    id: string
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
  actions: Array<
    | {
        __typename: 'FccWaypointDeliveryAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
      }
    | { __typename: 'FccWaypointHubReturnAction' }
    | {
        __typename: 'FccWaypointPickupAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
        notShownUpAt: string | null
        tripIsCancelled: boolean | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
      }
    | { __typename: 'FccWaypointReallocationAction' }
  >
  stop: {
    __typename?: 'Stop'
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
}

export const AdVehicleStreamWaypointAttendanceModalWaypointFragmentDoc = gql`
    fragment AdVehicleStreamWaypointAttendanceModalWaypoint on FccWaypoint {
  id
  adState
  ...GetPassengersWaypoint
  ...AdVehicleStreamBoardingPassengersWaypoint
  ...AdWaypointPassengersWaypoint
  ...AdVehicleStreamAlertVehicleMapWaypoint
}
    `
export const AdVehicleStreamUpcomingWaypointsDocument = gql`
    query AdVehicleStreamUpcomingWaypoints($vehicleId: ID!) {
  vehicle: vehicleByID(id: $vehicleId) {
    id
    upcomingWaypoints: fccUpcomingWaypoints {
      ...AdVehicleStreamWaypointAttendanceModalWaypoint
      ...AdVehicleStreamEvaluateCabinSafetyCheckStatus
    }
  }
}
    ${AdVehicleStreamWaypointAttendanceModalWaypointFragmentDoc}
${GetPassengersWaypointFragmentDoc}
${GetPassengersPickupActionFragmentDoc}
${AdPassengerRowCustomerFragmentDoc}
${GetPassengersDeliveryActionFragmentDoc}
${AdVehicleStreamBoardingPassengersWaypointFragmentDoc}
${AdWaypointPassengersWaypointFragmentDoc}
${AdVehicleStreamAlertVehicleMapWaypointFragmentDoc}
${AdVehicleStreamAlertVehicleMapLocationFragmentDoc}
${AdVehicleStreamEvaluateCabinSafetyCheckStatusFragmentDoc}`

/**
 * __useAdVehicleStreamUpcomingWaypointsQuery__
 *
 * To run a query within a React component, call `useAdVehicleStreamUpcomingWaypointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamUpcomingWaypointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamUpcomingWaypointsQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamUpcomingWaypointsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdVehicleStreamUpcomingWaypointsQuery,
    AdVehicleStreamUpcomingWaypointsQueryVariables
  > &
    (
      | {
          variables: AdVehicleStreamUpcomingWaypointsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdVehicleStreamUpcomingWaypointsQuery,
    AdVehicleStreamUpcomingWaypointsQueryVariables
  >(AdVehicleStreamUpcomingWaypointsDocument, options)
}
export function useAdVehicleStreamUpcomingWaypointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdVehicleStreamUpcomingWaypointsQuery,
    AdVehicleStreamUpcomingWaypointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdVehicleStreamUpcomingWaypointsQuery,
    AdVehicleStreamUpcomingWaypointsQueryVariables
  >(AdVehicleStreamUpcomingWaypointsDocument, options)
}
// @ts-ignore
export function useAdVehicleStreamUpcomingWaypointsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdVehicleStreamUpcomingWaypointsQuery,
    AdVehicleStreamUpcomingWaypointsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamUpcomingWaypointsQuery,
  AdVehicleStreamUpcomingWaypointsQueryVariables
>
export function useAdVehicleStreamUpcomingWaypointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamUpcomingWaypointsQuery,
        AdVehicleStreamUpcomingWaypointsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamUpcomingWaypointsQuery | undefined,
  AdVehicleStreamUpcomingWaypointsQueryVariables
>
export function useAdVehicleStreamUpcomingWaypointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamUpcomingWaypointsQuery,
        AdVehicleStreamUpcomingWaypointsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdVehicleStreamUpcomingWaypointsQuery,
    AdVehicleStreamUpcomingWaypointsQueryVariables
  >(AdVehicleStreamUpcomingWaypointsDocument, options)
}
export type AdVehicleStreamUpcomingWaypointsQueryHookResult = ReturnType<
  typeof useAdVehicleStreamUpcomingWaypointsQuery
>
export type AdVehicleStreamUpcomingWaypointsLazyQueryHookResult = ReturnType<
  typeof useAdVehicleStreamUpcomingWaypointsLazyQuery
>
export type AdVehicleStreamUpcomingWaypointsSuspenseQueryHookResult =
  ReturnType<typeof useAdVehicleStreamUpcomingWaypointsSuspenseQuery>
export type AdVehicleStreamUpcomingWaypointsQueryResult = Apollo.QueryResult<
  AdVehicleStreamUpcomingWaypointsQuery,
  AdVehicleStreamUpcomingWaypointsQueryVariables
>
